(ns authentication.events
  (:require
   [very.re-frame.core :as rf]
   [graphql.core :as qu]))

(defn submit [db]
  (assoc-in db [:authentication/form] {:error? false
                                       :message nil
                                       :submitting? true}))

(defn returned [db]
  (assoc-in db [:authentication/form :submitting?] false))

(rf/reg-event-db
  :authentication/initialize-authentication
  (fn [db]
    (assoc db :authentication/form {:error? false
                                    :message nil
                                    :submitting? false})))

(rf/reg-sub
 :authentication/mfa
 (fn [db]
   (:authentication/mfa db)))

(rf/reg-event-fx
 :authentication/identify-session
 (fn [cfx]
   (let [k (-> cfx :db :uri :paths last)]
     {:graphql {:gql (qu/invite {:identifier-key k})
                :success [:authentication/identifiable]
                :error [:authentication/unidentifiable]
                :allow-unauth? true}})))

(rf/reg-event-db
 :authentication/identifiable
 (fn [db [{:keys [invite]}]]
   (assoc-in db [:authentication :client] invite)))

(rf/reg-sub
 :authentication/client
 (comp :client :authentication))

(rf/reg-event-db
 :authentication/unidentifiable
 identity)

(rf/reg-event-fx
 :log-in
 [(rf/enrich submit)]
 (fn [cfx [data]]
   {:graphql {:gql (qu/valid-client {:input data})
              :success [:valid-credentials]
              :error [:invalid-credentials]
              :failure [:authentication-failure]
              :allow-unauth? true}}))

(rf/reg-event-fx
 :authentication/verify-mfa
 [(rf/enrich submit)]
 (fn [cfx [data]]
   {:graphql {:gql (qu/create-session {:input {:otp-token (:otp-token data)
                                               :client-id (get-in cfx [:db :authentication/mfa :id])}})
              :success [:session-created]
              :error [:authentication/invalid-mfa]
              :failure [:authentication/mfa-failure]
              :allow-unauth? true}}))

(rf/reg-event-db
 :authentication/invalid-mfa
 (fn [db]
   (assoc-in db [:authentication/mfa :error?] true)))

(rf/reg-event-db
 :authentication/mfa-failure
 (fn [db]
   (assoc-in db [:authentication/mfa :failure?] true)))

(rf/reg-event-db
  :authentication/mfa-remove-code
  (fn [db]
    (assoc-in db [:authentication/mfa :code] nil)))

(rf/reg-event-fx
 :valid-credentials
 (fn [cfx [{:keys [valid-client]}]]
   {:db (assoc (:db cfx) :authentication/mfa {:id (:id valid-client)
                                              :code (:otp-qr-code valid-client)})
    :nav! "/login/mfa"}))

(rf/reg-event-fx
 :session-created
 (fn [cfx [data]]
   (let [token (get-in data [:create-session :token])]
     {:session [:set [:token token]]
      :dispatch [:validate-session "/"]
      :db (assoc (:db cfx) :authentication/mfa {})})))

(rf/reg-event-db
 :invalid-credentials
 [(rf/enrich returned)]
 (fn [db [{:keys [errors]}]]
   (assoc db :authentication/form {:error? true
                                   :message (get-in errors [0 :message])})))

(rf/reg-event-db
 :authentication-failure
 [(rf/enrich returned)]
 (fn [db [{:keys [status-text]}]]
   (assoc db :authentication/form {:error? true
                                   :message "We are unable to reach the authentication system. This incident has been reported. Please try again shortly."})))

(rf/reg-event-fx
 :forgot-password
 [(rf/enrich returned)]
 (fn [cfx]
   {:nav! "/login/forgot"}))

(rf/reg-event-fx
 :request-password-reset
 [(rf/enrich submit)]
 (fn [_ [data]]
   {:graphql {:gql (qu/request-password-reset {:input data})
              :success [:password-reset-request-success]
              :error [:password-reset-error]
              :failure [:authentication-failure]}}))

(rf/reg-event-db
 :password-reset-request-success
 [(rf/enrich returned)]
 (fn [db [data]]
   (assoc db :authentication/form {:error? false
                                   :message "Your password request reset was successful. Please check your email."})))

(rf/reg-event-db
 :password-reset-error
 [(rf/enrich returned)]
 (fn [db [{:keys [errors]}]]
   (assoc db :authentication/form {:error? true
                                   :message (get-in errors [0 :message])})))

(rf/reg-event-fx
 :reset-password
 [(rf/enrich submit)]
 (fn [_ [data]]
   {:graphql {:gql (qu/reset-password
                    {:input data})
              :success [:password-reset-success]
              :error [:password-reset-error]
              :failure [:authentication-failure]}}))

(rf/reg-event-fx
 :set-password
 [(rf/enrich submit)]
 (fn [cfx [data]]
   ;; @TODO eventually the router should provide these params nice and parsed
   (let [invite-key (-> cfx :db :uri :paths last)]
     {:graphql {:gql (qu/reset-password
                      {:input {:key invite-key
                               :password (:password data)}})
                :success [:password-reset-success]
                :error [:password-reset-error]
                :failure [:authentication-failure]}})))

(rf/reg-event-fx
 :password-reset-success
 [(rf/enrich returned)]
 (fn [cfx]
   {:nav! "/login"}))

(rf/reg-sub
 :authentication/form
 (fn [db]
   (:authentication/form db)))
